// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__Rqjqw","disabledOutline":"button_disabledOutline__aeQFL","loader":"button_loader__cZtQo","spin":"button_spin__aZCp8"};